import React from 'react';
import { Bell, Home, BookOpen, BarChart2, Award, Settings, Plus, Menu } from 'lucide-react';
interface HeaderProps {
  onOpenSidebar?: () => void;
}
export function Header({
  onOpenSidebar
}: HeaderProps) {
  return <div className="flex items-center justify-between px-4 md:px-8 py-3 md:py-4 border-b border-gray-200 bg-white" data-id="element-428">
      {/* Mobile Layout */}
      <div className="md:hidden flex items-center justify-between w-full" data-id="element-429">
        {/* Logo - Left */}
        <div className="text-red-600 font-bold text-lg" data-id="element-430">LOGO</div>
        {/* Contents Button - Center */}
        <button onClick={onOpenSidebar} className="flex items-center gap-2 text-gray-700 hover:text-gray-900 transition-colors absolute left-1/2 -translate-x-1/2" data-id="element-431">
          <Menu size={20} data-id="element-432" />
          <span className="text-sm font-medium" data-id="element-433">Contents</span>
        </button>
        {/* Right Side - Notifications and User */}
        <div className="flex items-center gap-3" data-id="element-434">
          <div className="relative" data-id="element-435">
            <Bell size={18} data-id="element-436" />
            <span className="absolute -top-1 -right-1 bg-red-500 rounded-full w-2 h-2" data-id="element-437"></span>
          </div>
          <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-xs" data-id="element-438">
            LT
          </div>
        </div>
      </div>
      {/* Desktop Layout */}
      <div className="hidden md:flex items-center justify-between w-full" data-id="element-439">
        <div className="flex items-center gap-8" data-id="element-440">
          <div className="text-red-600 font-bold text-xl" data-id="element-441">LOGO</div>
          <nav className="hidden lg:flex items-center gap-6" data-id="element-442">
            <NavItem icon={<Home size={18} data-id="element-444" />} label="Learner Dashboard" data-id="element-443" />
            <NavItem icon={<Plus size={18} data-id="element-446" />} label="Add Skills" data-id="element-445" />
            <NavItem icon={<BarChart2 size={18} data-id="element-448" />} label="Analytics" data-id="element-447" />
            <NavItem icon={<Award size={18} data-id="element-450" />} label="Achievements" data-id="element-449" />
            <NavItem icon={<Settings size={18} data-id="element-452" />} label="Settings" data-id="element-451" />
          </nav>
        </div>
        <div className="flex items-center gap-4" data-id="element-453">
          <div className="relative" data-id="element-454">
            <Bell size={20} data-id="element-455" />
            <span className="absolute -top-1 -right-1 bg-red-500 rounded-full w-2 h-2" data-id="element-456"></span>
          </div>
          <div className="flex items-center" data-id="element-457">
            <div className="w-8 h-8 rounded-full bg-gray-200 mr-2 flex items-center justify-center text-gray-600 text-sm" data-id="element-458">
              LT
            </div>
            <span className="hidden lg:block text-sm" data-id="element-459">Linda Taylor</span>
          </div>
        </div>
      </div>
    </div>;
}
function NavItem({
  icon,
  label,
  active = false
}) {
  return <div className={`flex items-center cursor-pointer ${active ? 'text-red-600' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-460">
      <span className="mr-2" data-id="element-461">{icon}</span>
      <span className="text-sm" data-id="element-462">{label}</span>
    </div>;
}